/** True when an axios/fetch request was aborted (AbortController, superseded in-flight call, etc.). */
export function isAxiosRequestAborted(error: unknown): boolean {
    if (!error || typeof error !== 'object') return false;
    const row = error as { name?: string; code?: string; message?: string };
    return (
        row.name === 'CanceledError' ||
        row.name === 'AbortError' ||
        row.code === 'ERR_CANCELED' ||
        row.message === 'canceled'
    );
}
